import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CrowdstrikeService } from '../../service';

export type AntiMalwareConfig = typeof AntiMalwareConfig._.Config;

export const AntiMalwareConfig = IntegrationConfig.make({
  service: CrowdstrikeService,
  name: Integration_Handler_Names_Enum.AntiMalware,
  configSchema: z.object({}),
});
